import { WidgetLocation } from "./WidgetLocation";

export abstract class AbstractWidgetElement {
	public eventId: string;
	public location: WidgetLocation;
	public isPinned?: boolean;
	public teamOneName: string;
	public teamTwoName: string;
	public sport?: string;
}
